/**
 * Module dependencies.
 */

import { animationTime } from './home-carousel.style';
import { ifProp } from 'styled-tools';
import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

/**
 * Fade in up keyframes.
 */

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(60px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

/**
 * Export `Wrapper` styled component.
 */

export const Wrapper = styled.div`
  margin-top: 64px;
  width: 370px;
  display: flex;
  opacity: 0;
  animation: ${fadeInUp} ${animationTime} ease-in-out;
  animation-delay: 1.5s;
  animation-fill-mode: forwards;
`;

/**
 * Export `Ball` styled component.
 */

export const Ball = styled.div<{
  isVisible: boolean;
}>`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 1.5px solid #fff;
  margin: 0 8px;
  transition: background-color 0.6s ease-in-out;
  cursor: pointer;

  &:first-child {
    margin-left: 0;
  }

  ${ifProp('isVisible', 'background-color: #fff;')}
`;
